import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography
} from '@mui/material';
import successIcon from '../../assets/images/success.png';

const UploadSuccessModal = ({ open, onClose,selectedFilescount,
    successCount }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Confirmation</DialogTitle>
    <DialogContent>
      <div style={{ textAlign: 'center', marginBottom: '15px' }}>
        <img
          src={successIcon}
          alt="Success"
          style={{ width: '80px', height: '80px', marginBottom: '10px' }}
        />
        <Typography variant="subtitle1" component="div">
          <ul style={{ margin: 0, paddingLeft: '1.25rem', textAlign: 'left' }}>
            <li>File sent to WIN successfully! {selectedFilescount}\{successCount}</li>
          </ul>
        </Typography>
      </div>
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        variant="contained"
        sx={{
          backgroundColor: '#ec008c',
          color: 'white',
          '&:hover': {
            backgroundColor: '#d5006d',
          },
        }}
      >
        OK
      </Button>
    </DialogActions>
  </Dialog>
);

export default UploadSuccessModal;